/**
 * Depuración del pipeline **previo y hasta el envío** firmado (simulate / gas / `writeContract`),
 * antes de que el `TransactionUpdater` busque el receipt.
 *
 * Activar **sin rebuild**:
 *   localStorage.setItem('DEBUG_TX_SUBMIT', '1'); location.reload()
 *   (también `'true'`.)
 *
 * Activar **por build**:
 *   VITE_DEBUG_TX_SUBMIT=true
 *
 * Guía canónica: `docs/500-guias/logs-debug-y-flags.md`.
 */

import { localStorageDebugOn, viteEnvDebugTrue } from './debugActivation'

const LS_PRIMARY = 'DEBUG_TX_SUBMIT'

const LOG_PREFIX = '[TX_SUBMIT]'

function stamp(): string {
  return new Date().toISOString()
}

export function isTxSubmitDebugEnabled(): boolean {
  if (viteEnvDebugTrue(import.meta.env.VITE_DEBUG_TX_SUBMIT)) return true
  if (typeof window === 'undefined') return false
  try {
    if (localStorageDebugOn(window.localStorage?.getItem(LS_PRIMARY))) return true
  } catch {
    /* sin localStorage */
  }
  return false
}

export function txSubmitDebug(tag: string, payload?: Record<string, unknown>): void {
  if (!isTxSubmitDebugEnabled()) return
  // eslint-disable-next-line no-console
  console.log(LOG_PREFIX, stamp(), tag, payload ?? {})
}

export function txSubmitWarn(tag: string, payload?: Record<string, unknown>): void {
  if (!isTxSubmitDebugEnabled()) return
  // eslint-disable-next-line no-console
  console.warn(LOG_PREFIX, stamp(), tag, payload ?? {})
}
